import $ from "jquery";

export const mixinModal = {
  methods: {
    showModal(id) {
      if (id) $("#" + id).modal();
    },
    closeModal(id) {
      if (id) $("#" + id).modal("hide");
    },
  },
};
